<!-- src/views/DashboardView.vue -->

<template>
  <div class="row">
    <div class="col-md-12">
      <div ref="carousel" class="carousel">
        <div
          v-for="banner in banners"
          :key="banner.id"
          class="carousel-cell"
          @click="navigateBanner(banner)"
        >
          <img :src="banner.image_url" class="banner-img" />
        </div>
      </div>
    </div>
  </div>
  <br />
</template>

<script>
import Flickity from "flickity";
import "flickity/css/flickity.css";
import { apiUrl } from "@/utils/api";

export default {
  name: "bannersHome",
  data() {
    return {
      banners: [],
    };
  },
  async mounted() {
    await this.fetchBanners();

    this.$nextTick(() => {
      const carouselElement = this.$refs.carousel;
      if (carouselElement) {
        new Flickity(carouselElement, {
          contain: true,
          autoPlay: true,
          wrapAround: true,
          cellAlign: "left",
        });
      }
    });
  },
  methods: {
    async fetchBanners() {
      try {
        const response = await fetch(`${apiUrl}/home/web`);
        const jsonResponse = await response.json();
        this.banners = jsonResponse.banners;
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    navigateBanner(banner) {
      switch (banner.type) {
        case "course":
          // مثال
          window.open(`/course-details?id=${banner.type_id}`, "_blank");
          break;

        case "bundle":
          window.open(`/bundle-details?id=${banner.type_id}`, "_blank");
          break;

        case "instructor":
          window.open(`/instructor-profile?id=${banner.type_id}`, "_blank");
          break;

        case "external":
          window.open(banner.external_url, "_blank");
          break;
      }
    },
  },
};
</script>
<style scoped>
/* Carousel container */
.carousel {
  height: 350px; /* ⬅️ ارتفاع كامل للcarousel */
}

/* Carousel cells */
.carousel-cell {
  width: calc(100% - 10px);
  margin-right: 10px;
  height: 100%; /* ⬅️ يملأ ارتفاع الcarousel */
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 992px) {
  .carousel-cell {
    width: calc(50% - 10px);
    margin-right: 10px;
    height: 100%;
  }
}

.carousel-cell {
  cursor: pointer;
}

/* Banner image */
.banner-img {
  width: 95%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.carousel-cell:hover .banner-img {
  transform: scale(1.03);
  box-shadow: 0 8px 14px rgba(0, 0, 0, 0.15);
}
</style>
